import { render, staticRenderFns } from "./dataHistory.vue?vue&type=template&id=4c8e4bb6&scoped=true"
import script from "./dataHistory.vue?vue&type=script&lang=js"
export * from "./dataHistory.vue?vue&type=script&lang=js"
import style0 from "./dataHistory.vue?vue&type=style&index=0&id=4c8e4bb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8e4bb6",
  null
  
)

export default component.exports